import { render } from "./Btn.vue?vue&type=template&id=568a8bee&scoped=true&ts=true"
import script from "./Btn.vue?vue&type=script&lang=ts"
export * from "./Btn.vue?vue&type=script&lang=ts"

import "./Btn.vue?vue&type=style&index=0&id=568a8bee&lang=postcss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568a8bee"]])

export default __exports__